module.exports = __webpack_public_path__ + "img/customer-img4.de3b11c1.png";